import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { cn } from '../lib/utils';
import { Button } from '../components/ui/button';
import { ScrollArea } from '../components/ui/scroll-area';
import { Separator } from '../components/ui/separator';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import {
  LayoutDashboard,
  Bell,
  Settings,
  TrendingUp,
  Wallet,
  CreditCard,
  Upload,
  Receipt,
  FileText,
  Calculator,
  Calendar,
  Clock,
  Coins,
  BarChart3,
  ChevronLeft,
  ChevronRight,
  Moon,
  Sun,
  User,
  LogOut,
  Menu,
  X,
  Package,
  Users,
  ChefHat,
  CloudSun,
  CalendarDays,
  ShoppingBag,
  Briefcase,
  ClipboardList,
  KeyRound,
  Lock,
  Truck,
  GraduationCap,
  Rocket,
  Star,
  ScanLine,
  Snowflake,
  ShieldCheck,
  Activity,
  Sparkles,
  Flame,
  FlaskConical
} from 'lucide-react';

const menuItems = [
  { id: 'realtime', label: 'Temps Reel', icon: Activity, path: '/temps-reel' },
  { id: 'insights', label: 'Business Insights IA', icon: Sparkles, path: '/insights' },
  { id: 'dashboard', label: 'Tableau de bord', icon: LayoutDashboard, path: '/' },
  { id: 'params', label: 'Paramètres', icon: Settings, path: '/parametres' },
  { id: 'notifications', label: 'Alertes & Notifications', icon: Bell, path: '/notifications' },
  { type: 'separator', label: 'Revenus' },
  { id: 'forecast', label: 'Forecast CA', icon: TrendingUp, path: '/forecast-ca' },
  { id: 'ca-reel', label: 'CA Réel', icon: Wallet, path: '/ca-reel' },
  { id: 'plateformes', label: 'Plateformes', icon: CreditCard, path: '/plateformes' },
  { id: 'uber-verif', label: 'Vérif. Uber', icon: Truck, path: '/uber-verification' },
  { type: 'separator', label: 'Dépenses' },
  { id: 'linxo', label: 'Import Linxo', icon: Upload, path: '/linxo' },
  { id: 'depenses', label: 'Dépenses', icon: Receipt, path: '/depenses' },
  { id: 'recap-depenses', label: 'Récap Dépenses', icon: FileText, path: '/recap-depenses' },
  { type: 'separator', label: 'Finance' },
  { id: 'tva', label: 'TVA', icon: Calculator, path: '/tva' },
  { id: 'especes', label: 'Vérif. Espèces', icon: Coins, path: '/verification-especes' },
  { id: 'enveloppe', label: 'Vérif Enveloppe', icon: Coins, path: '/verification-enveloppe', public: true },
  { type: 'separator', label: 'Planning' },
  { id: 'planning', label: 'Planning Prévu', icon: Calendar, path: '/planning' },
  { id: 'synthese', label: 'Synthèse Planning', icon: Clock, path: '/synthese-planning' },
  { type: 'separator', label: 'Analyse' },
  { id: 'dashboard2', label: 'Dashboard KPI', icon: BarChart3, path: '/dashboard-kpi' },
  { id: 'dashboard-depenses', label: 'Dashboard Depenses', icon: Receipt, path: '/dashboard-depenses' },
  { id: 'analyse-ventes', label: 'Analyse Ventes', icon: ShoppingBag, path: '/analyse-ventes' },
  { type: 'separator', label: 'Stock' },
  { id: 'inventaire', label: 'Inventaire', icon: Package, path: '/inventaire' },
  { id: 'livraisons-labo', label: 'Livraisons Labo', icon: FlaskConical, path: '/livraisons-labo' },
  { id: 'commandes', label: 'Commandes fournisseurs', icon: Truck, path: '/commandes' },
  { id: 'pertes', label: 'Compteur de Pertes', icon: Flame, path: '/pertes' },
  { type: 'separator', label: 'Traiteur' },
  { id: 'traiteur', label: 'Commandes Traiteur', icon: ChefHat, path: '/traiteur' },
  { type: 'separator', label: 'Météo' },
  { id: 'meteo', label: 'Météo', icon: CloudSun, path: '/meteo' },
  { type: 'separator', label: 'Social Media' },
  { id: 'social', label: 'Calendrier Social', icon: CalendarDays, path: '/social-calendar' },
  { id: 'marketing', label: 'Booster Marketing', icon: Rocket, path: '/marketing' },
  { id: 'fidelite', label: 'Fidelite', icon: Star, path: '/fidelite' },
  { id: 'rentabilite', label: 'Rentabilite Plats', icon: ChefHat, path: '/rentabilite' },
  { id: 'mercuriale', label: 'Mercuriale & Factures', icon: ScanLine, path: '/mercuriale' },
  { type: 'separator', label: 'HACCP / Qualite' },
  { id: 'ouverture', label: 'Ouverture Shop', icon: Sparkles, path: '/ouverture' },
  { id: 'fin-midi', label: 'Fin service midi', icon: Sun, path: '/fin-midi' },
  { id: 'fermeture-soir', label: 'Fermeture soir', icon: Moon, path: '/fermeture-soir' },
  { id: 'decongelation', label: 'Decongelation', icon: Snowflake, path: '/decongelation' },
  { id: 'hygiene', label: 'Hygiene & HACCP', icon: ShieldCheck, path: '/hygiene' },
  { type: 'separator', label: 'Operations' },
  { id: 'transmission', label: 'Transmission Service', icon: ClipboardList, path: '/transmission' },
  { id: 'procedures', label: 'Procédures', icon: ClipboardList, path: '/procedures' },
  { type: 'separator', label: 'RH' },
  { id: 'rh', label: 'Ressources Humaines', icon: Briefcase, path: '/rh' },
  { id: 'qcm', label: 'QCM Formation', icon: ClipboardList, path: '/qcm' },
  { id: 'formation', label: 'Planning Formation', icon: GraduationCap, path: '/formation' },
  { type: 'separator', label: 'Zone Secrète' },
  { id: 'recettes-secretes', label: 'Recettes Secrètes', icon: Lock, path: '/recettes-secretes' },
  { id: 'calculateur-prep', label: 'Calculateur Prép.', icon: Calculator, path: '/calculateur-prep' },
];

export function MainLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className={cn(
        "flex items-center h-16 px-4 border-b border-border/50",
        collapsed ? "justify-center" : "gap-3"
      )}>
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <span className="text-primary font-bold text-lg">CP</span>
        </div>
        {!collapsed && (
          <div className="flex flex-col">
            <span className="font-heading font-bold text-lg leading-tight">Chana Poke</span>
            <span className="text-xs text-muted-foreground">Thai KPI</span>
          </div>
        )}
      </div>

      {/* Navigation */}
      <ScrollArea className="flex-1 py-4">
        <nav className="px-3 space-y-1">
          {menuItems.map((item, index) => {
            if (item.type === 'separator') {
              return (
                <div key={index} className={cn("pt-4 pb-2", collapsed && "hidden")}>
                  <span className="px-3 text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    {item.label}
                  </span>
                </div>
              );
            }

            // Check permissions: admin sees all, others need the module in their permissions
            const moduleId = item.id === 'params' ? 'parametres' : item.id === 'dashboard' ? 'dashboard' : item.id === 'forecast' ? 'forecast-ca' : item.id === 'especes' ? 'verification-especes' : item.id === 'planning' ? 'planning' : item.id === 'synthese' ? 'synthese-planning' : item.id === 'dashboard2' ? 'dashboard-kpi' : item.id;
            if (!item.public && user?.role !== 'admin' && user?.permissions && user.permissions.length > 0 && !user.permissions.includes(moduleId)) {
              return null;
            }

            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.id}
                to={item.path}
                data-testid={`nav-${item.id}`}
                className={cn(
                  "sidebar-link",
                  isActive && "active",
                  collapsed && "justify-center px-2"
                )}
                title={collapsed ? item.label : undefined}
              >
                <Icon className="w-5 h-5 flex-shrink-0" />
                {!collapsed && <span>{item.label}</span>}
              </Link>
            );
          })}

          {/* Admin section */}
          {user?.role === 'admin' && (
            <>
              <div className={cn("pt-4 pb-2", collapsed && "hidden")}>
                <span className="px-3 text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Administration
                </span>
              </div>
              <Link
                to="/pilotage"
                data-testid="nav-pilotage"
                className={cn(
                  "sidebar-link",
                  location.pathname === '/pilotage' && "active",
                  collapsed && "justify-center px-2"
                )}
                title={collapsed ? 'Pilotage Financier' : undefined}
              >
                <TrendingUp className="w-5 h-5 flex-shrink-0" />
                {!collapsed && <span>Pilotage Financier</span>}
              </Link>
              <Link
                to="/admin/users"
                data-testid="nav-admin-users"
                className={cn(
                  "sidebar-link",
                  location.pathname === '/admin/users' && "active",
                  collapsed && "justify-center px-2"
                )}
                title={collapsed ? 'Utilisateurs' : undefined}
              >
                <Users className="w-5 h-5 flex-shrink-0" />
                {!collapsed && <span>Utilisateurs</span>}
              </Link>
            </>
          )}
        </nav>
      </ScrollArea>

      {/* Collapse toggle */}
      <div className="hidden md:flex p-3 border-t border-border/50">
        <Button
          variant="ghost"
          size="sm"
          className="w-full justify-center"
          onClick={() => setCollapsed(!collapsed)}
          data-testid="sidebar-toggle"
        >
          {collapsed ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
        </Button>
      </div>
    </div>
  );

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar - Desktop */}
      <aside
        className={cn(
          "hidden md:flex flex-col border-r border-border/50 bg-card/50 backdrop-blur-sm transition-all duration-300",
          collapsed ? "w-[70px]" : "w-[260px]"
        )}
      >
        <SidebarContent />
      </aside>

      {/* Mobile sidebar overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Sidebar - Mobile */}
      <aside
        className={cn(
          "fixed inset-y-0 left-0 z-50 w-[260px] bg-card border-r border-border/50 transform transition-transform duration-300 md:hidden",
          mobileOpen ? "translate-x-0" : "-translate-x-full"
        )}
      >
        <SidebarContent />
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <header className="h-16 border-b border-border/50 bg-card/50 backdrop-blur-sm flex items-center justify-between px-4 md:px-6">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              className="md:hidden"
              onClick={() => setMobileOpen(true)}
              data-testid="mobile-menu-btn"
            >
              <Menu className="w-5 h-5" />
            </Button>
            <h1 className="font-heading font-semibold text-lg truncate">
              {menuItems.find(i => i.path === location.pathname)?.label || 'Tableau de bord'}
            </h1>
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleTheme}
              data-testid="theme-toggle"
            >
              {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            </Button>

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="gap-2" data-testid="user-menu">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <User className="w-4 h-4 text-primary" />
                  </div>
                  <span className="hidden sm:inline text-sm font-medium">{user?.nom}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                <div className="px-2 py-1.5">
                  <p className="text-sm font-medium">{user?.nom}</p>
                  <p className="text-xs text-muted-foreground">{user?.email}</p>
                </div>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate('/change-password')} data-testid="change-password-btn">
                  <KeyRound className="w-4 h-4 mr-2" />
                  Changer mot de passe
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleLogout} data-testid="logout-btn">
                  <LogOut className="w-4 h-4 mr-2" />
                  Déconnexion
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-auto">
          <div className="page-container animate-fade-in">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
